module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray pb-fixed-btn"
  }, [_c('backTitleBar'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "card flex pd-200"
  }, [_c('div', {
    staticClass: "flex1 text-center"
  }, [_c('div', {
    staticClass: "phone-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.phoneImg,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-10 fs-30 color-666"
  }, [_vm._v("电话客服")]), _vm._v(" "), _c('div', {
    staticClass: "mt-10 fs-26 color-666"
  }, [_vm._v("服务时间 9:00-18:30")])])]), _vm._v(" "), _c('div', {
    staticClass: "card mt-20"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v("我要反馈")]), _vm._v(" "), _c('div', {
    staticClass: "pd-25"
  }, [_c('div', {
    staticClass: "option-list"
  }, _vm._l((_vm.optionList), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "option-item",
      class: {
        'active': _vm.curOption == item.value
      },
      on: {
        "click": function($event) {
          _vm.curOption = item.value
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formItem.content),
      expression: "formItem.content"
    }],
    staticClass: "contact-advice",
    attrs: {
      "placeholder": "您可以在这里输入内容"
    },
    domProps: {
      "value": (_vm.formItem.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formItem, "content", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex filed-input-box",
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, [_vm._l((_vm.formItem.imgList), function(item, $index) {
    return _c('div', {
      key: item.fileId,
      staticClass: "pic-box"
    }, [_c('img', {
      attrs: {
        "src": item.fileUrlView,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "clean",
      on: {
        "click": function($event) {
          return _vm.delImg($index)
        }
      }
    })])
  }), _vm._v(" "), _c('van-uploader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formItem.imgList.length < 5),
      expression: "formItem.imgList.length < 5"
    }],
    attrs: {
      "preview-size": "1.45rem",
      "preview-image": false,
      "after-read": _vm.afterRead
    },
    model: {
      value: (_vm.imgList),
      callback: function($$v) {
        _vm.imgList = $$v
      },
      expression: "imgList"
    }
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "card mt-20 mb-20 pd-025"
  }, [_c('div', {
    staticClass: "input-field bd-bot"
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("联系方式")]), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "tel",
      "clearable": true,
      "placeholder": "输入您的手机号"
    },
    model: {
      value: (_vm.formItem.mobile),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "mobile", $$v)
      },
      expression: "formItem.mobile"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "fixed-bot"
  }, [_c('div', {
    staticClass: "btn click",
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("提交")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-435746f6","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/My/contact.vue
// module id = uDtC
// module chunks = 51